class Lightbox {
	constructor(el) {
		this.el = el;
		this.shouldShow = false;
		this.close = this.el.querySelector(".lightbox__close");

		this.init();
	}

	init() {
		this.readLocalStorage();
		this.el.addEventListener("click", this.hideLightbox.bind(this));
		this.close.addEventListener("click", this.hideLightbox.bind(this));
		window.addEventListener("scroll", this.showLightboxOnScroll.bind(this));
	}

	showLightboxOnScroll() {
		if (
			window.scrollY > 2000 &&
			!this.el.classList.contains("shown") &&
			this.shouldShow
		) {
			this.showLightbox();
		}
	}

	showLightbox() {
		this.el.classList.add("show");
		this.el.classList.add("shown");
		// set seen expiration to be seven days from the time this is set
		localStorage.setItem(
			"ctc-hubspot-lightbox-seen-exp",
			JSON.stringify(Date.now() + 7 * 24 * 60 * 60 * 1000)
		);
		document.body.classList.add("no-scroll");
	}

	hideLightbox() {
		this.el.classList.remove("show");
		document.body.classList.remove("no-scroll");
	}

	readLocalStorage() {
		const lightboxSeenExp = JSON.parse(
			localStorage.getItem("ctc-hubspot-lightbox-seen-exp")
		);

		// if the expiration date is less than now, the expiration has passed
		const seenExpired = lightboxSeenExp <= Date.now();

		// if the expiration has passed, or we weren't able to retrieve an expiration date, allow the lightbox to show and clear the local data
		if (seenExpired || !lightboxSeenExp) {
			localStorage.removeItem("ctc-hubspot-lightbox-seen-exp");
			this.shouldShow = true;
		}
	}
}

window.addEventListener("DOMContentLoaded", () => {
	const lightboxes = document.querySelectorAll(".lightbox__container");

	lightboxes.forEach((b) => {
		new Lightbox(b);
	});
});
